import { render, staticRenderFns } from "./OrderConfirm-company.vue?vue&type=template&id=562542b2"
import script from "./OrderConfirm-company.vue?vue&type=script&lang=js"
export * from "./OrderConfirm-company.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirm-company.vue?vue&type=style&index=0&id=562542b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports